<template>
  <div class="weekly-list-notice"
       :class="type"
  >
    <ym-img class="header"
            :src="require(`@/assets/img/million_read/weekly/${type}_header.png`)"
    />
    <div class="body">
      <slot></slot>
    </div>
    <ym-img class="footer"
            :src="require(`@/assets/img/million_read/weekly/${type}_footer.png`)"
    />
    <ym-img class="left"
            :src="require(`@/assets/img/million_read/weekly/${type}_left.png`)"
    />
    <ym-img class="right"
            :src="require(`@/assets/img/million_read/weekly/${type}_right.png`)"
    />
  </div>
</template>

<script>
  export default {
    name: 'MillionReadWeeklyReportNoticeItem',
    props: {
      type: {
        type: String,
        required: true,
      },
    },
    methods: {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .weekly-list-notice {
    position: relative;
    margin-bottom: 110px;
    .header,
    .footer {
      display: block;
      width: 100%;
    }
    .header {
      margin-top: 1px;
    }
    .footer {
      margin-top: -1px;
    }
    .left {
      position: absolute;
      left: 0;
    }
    .right {
      position: absolute;
      right: 0;
    }
    &.persevere {
      .header {
        height: 375px;
      }
      .body {
        min-height: 440px;
        background-image: url('~@/assets/img/million_read/weekly/persevere_body.png');
        background-size: 100%;
        background-repeat: repeat-y;
      }
      .footer {
        height: 129px;
      }
      .left {
        width: 127px;
        height: 417px;
        bottom: 89px;
      }
      .right {
        width: 121px;
        height: 440px;
        bottom: 89px;
      }
    }
    &.interaction {
      .header {
        height: 290px;
      }
      .body {
        min-height: 421px;
        background-image: url('~@/assets/img/million_read/weekly/interaction_body.png');
        background-size: 100%;
        background-repeat: repeat-y;
      }
      .footer {
        height: 154px;
      }
      .left {
        width: 185px;
        height: 415px;
        bottom: 47px;
      }
      .right {
        width: 135px;
        height: 421px;
        bottom: 47px;
      }
    }
    &.diligence {
      .header {
        height: 336px;
      }
      .body {
        min-height: 285px;
        background-image: url('~@/assets/img/million_read/weekly/diligence_body.png');
        background-size: 100%;
        background-repeat: repeat-y;
      }
      .footer {
        height: 154px;
      }
      .left {
        width: 194px;
        height: 273px;
        bottom: 64px;
      }
      .right {
        width: 148px;
        height: 285px;
        bottom: 64px;
      }
    }
  }
</style>
